import { render, staticRenderFns } from "./govAccount.vue?vue&type=template&id=5966fe5c&scoped=true"
import script from "./govAccount.vue?vue&type=script&lang=js"
export * from "./govAccount.vue?vue&type=script&lang=js"
import style0 from "./govAccount.vue?vue&type=style&index=0&id=5966fe5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5966fe5c",
  null
  
)

export default component.exports